import ApplicationController from "./application_controller"

/**
 * Fills the article sidebar's News rail from /news-rail/<category>/ (see includes/news-rail.php).
 *
 * The fragment holds the rail pre-rendered once per post it could leave out. This picks the one
 * that leaves out the article being read, or the default when that article isn't in it. On any
 * failure, or after 8 seconds, the placeholder is removed rather than left as an empty gap.
 */
export default class extends ApplicationController {
  static values = { url: String, exclude: Number }

  async connect () {
    if (this.isPreview) return

    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), 8000)

    try {
      const response = await fetch(this.urlValue, { credentials: "omit", signal: controller.signal })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const doc = new DOMParser().parseFromString(await response.text(), "text/html")
      const template = doc.querySelector(`template[data-exclude="${this.excludeValue}"]`) ||
        doc.querySelector('template[data-exclude="0"]')

      if (!template || !template.content.childElementCount) {
        this.element.remove()
        return
      }
      this.element.replaceWith(document.importNode(template.content, true))
    } catch (error) {
      console.warn("News rail not loaded:", error.message)
      this.element.remove()
    } finally {
      clearTimeout(timer)
    }
  }
}
